import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
export function date(d) {
  if (!d) {
    return null;
  }
  try {
    return new Date(d);
  } catch (_unused) {
    return null;
  }
}

// TODO: [TS:compiler.target=ES2020]: type HourCycle = Intl.DateTimeFormatOptions['hourCycle'];

export function getDateString(_ref) {
  var dateTime = _ref.dateTime,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? navigator.language : _ref$locale,
    _ref$systemOffset = _ref.systemOffset,
    systemOffset = _ref$systemOffset === void 0 ? 0 : _ref$systemOffset,
    _ref$readoutFunctions = _ref.readoutFunctions,
    readoutFunctions = _ref$readoutFunctions === void 0 ? {} : _ref$readoutFunctions;
  // Default hourCycle value
  var hourCycle = 'h24';
  var hourCycle12Languages = ['en-GB', 'en-US', 'es-ES'];
  if (hourCycle12Languages.includes(locale)) {
    // Set hourCycle to 12 for languages for which we want to display AM / PM
    hourCycle = 'h12';
  }

  // Set default readout functions
  var _readoutFunctions$sec = readoutFunctions.secondsAgoReadout,
    secondsAgoReadout = _readoutFunctions$sec === void 0 ? function (count) {
      return "".concat(count, " second").concat(count > 1 ? 's' : '', " ago");
    } : _readoutFunctions$sec,
    _readoutFunctions$min = readoutFunctions.minutesAgoReadout,
    minutesAgoReadout = _readoutFunctions$min === void 0 ? function (count) {
      return "".concat(count, " minute").concat(count > 1 ? 's' : '', " ago");
    } : _readoutFunctions$min;

  // Define the offset, how old is this...
  var time = date(dateTime);

  // DateString
  var dateString = 'n/a';

  // Default delay
  var delay = null;
  if (!time || isNaN(time.getTime())) {
    return {
      dateString: dateString,
      delay: delay
    };
  }

  // Update the system time
  var systemtime = new Date();
  systemtime.setTime(Date.now() + systemOffset);
  var offset = systemtime.getTime() - time.getTime();

  // Get the number of milliseconds since midnight in the local tz
  var ms_today = (Date.now() - new Date().getTimezoneOffset() * 1000 * 60) % ONE_DAY;

  // A few seconds ago
  if (offset < ONE_MINUTE) {
    var FIVE_SECONDS = ONE_SECOND * 5;
    delay = offset % FIVE_SECONDS || FIVE_SECONDS;
    var seconds = Math.round(offset / 1000);
    dateString = secondsAgoReadout(seconds || 1);
  }
  // A few minutes ago
  else if (offset < ONE_MINUTE * 10) {
    delay = offset % ONE_MINUTE || ONE_MINUTE;
    var mins = Math.round(offset / ONE_MINUTE);
    dateString = minutesAgoReadout(mins);
  }
  // Occured today...
  else if (offset < ms_today) {
    // Number of ms until end of the day...
    delay = ONE_DAY - ms_today;
    dateString = new Intl.DateTimeFormat(locale, {
      hourCycle: hourCycle,
      hour: 'numeric',
      minute: 'numeric'
    }).format(time);
  }
  // Occurred this week
  else if (offset < ONE_DAY * 6) {
    // Delay a day...
    delay = ONE_DAY;
    // Get day
    dateString = new Intl.DateTimeFormat(locale, {
      weekday: 'short',
      hourCycle: hourCycle,
      hour: 'numeric'
    }).format(time);
  } else if (time.getFullYear() === systemtime.getFullYear()) {
    dateString = new Intl.DateTimeFormat(locale, {
      month: 'short',
      day: 'numeric'
    }).format(time);
  } else {
    dateString = new Intl.DateTimeFormat(locale, {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).format(time);
  }
  return {
    dateString: dateString,
    delay: delay
  };
}